import React from "react";
import { withAppState, getAppState } from "../../state";
import { withFocusable } from "../../services/visualLibraryService";
import {
  HeaderStyled,
  ImageStyled,
  MainMenuContainerStyled,
  LogoWrapperStyled,
  LogoShadeStyled
} from "./styles/Styled";
import FreeLogo from "../../components/FreeLogo";
import { getLogger } from "../../utils/logger";
import { findFromBrands } from "../../helpers/find";
import { directions, i18n } from "../../services/i18nService";
import Logo from "../../components/Logo";

const MainMenuContainerFocus = withFocusable(MainMenuContainerStyled);

let isBrand;

let slider;

export const defaultFocusPath = "mainMenu";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: false,
      loaded: false,
      menuExpanded: false
    };
    this.handleFocusMenu = this.handleFocusMenu.bind(this);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.navigate = this.navigate.bind(this);
    this.logger = getLogger();
    this.brandName = null;
    this.imageUrlSubscription = "";
    this.imageUrlBrands = "";
    this.isActiveBrand = false;
  }

  componentDidUpdate() {
    let { addons } = this.props.applicationState;
    isBrand = window.location.pathname.indexOf("brands/");
    const names = isBrand && window.location.pathname.split("/");
    if (isBrand) {
      this.brandName = names[2];
      let subscription = findFromBrands(this.brandName, this.props.applicationState.subscriptions || []);
      let baseSubscription = findFromBrands(this.brandName, subscription?.brands);
      this.isActiveBrand = getAppState()?.addons?.find(
        addon =>
          (addon.name === subscription?.displayName || addon.name === this.brandName) &&
          addon?.status?.toLowerCase() === "active"
      );
      this.imageUrlSubscription =
        subscription?.displayName === "STARZPLAY"
          ? `${baseSubscription?.configuration.logoDefaultPNG}`
          : `${subscription?.configuration.logoDefaultPNG}`;
    } else {
      this.brandName = null;
    }
  }

  handleFocusMenu(focused) {
    this.setState({ activeMenu: focused });
  }

  navigate() {
    slider.navigate();
    slider.rightMenuHandler();
    this.handleToggleMenu(false);
  }

  up() {
    slider.left();
  }

  down() {
    slider.right();
  }
  left() {
    slider.left();
  }

  right() {
    slider.rightMenuHandler();
    // slider.right();
  }
  handleToggleMenu(focused) {
    this.setState({ menuExpanded: focused });
  }

  render() {
    return (
      <>
        {isBrand != 1 || this.isActiveBrand ? (
          <>
            <LogoShadeStyled></LogoShadeStyled>
            <LogoWrapperStyled brandName={this.brandName}>
              {!this.brandName ? <FreeLogo /> : <ImageStyled src={this.imageUrlSubscription} alt={this.brandName} />}
            </LogoWrapperStyled>
          </>
        ) : null}
        {!this.brandName && (
          <HeaderStyled className={"isActiveMenu"}>
            {/* this was before <HeaderStyled className={this.state.activeMenu && "isActiveMenu"}>*/}
            <React.Fragment>
              <MainMenuContainerFocus
                focusPath={defaultFocusPath}
                handleFocus={this.handleFocusMenu}
                onRef={ref => (slider = ref)}
                onLeft={i18n.getDirection() !== directions.LEFT_TO_RIGHT ? this.right : () => {}}
                onRight={i18n.getDirection() === directions.LEFT_TO_RIGHT ? this.right : () => {}}
                onDown={this.down}
                onUp={this.up}
                onEnterPress={this.navigate}
                handleToggleMenu={this.handleToggleMenu}
                menuExpanded={this.state.menuExpanded}
              />
            </React.Fragment>
          </HeaderStyled>
        )}
      </>
    );
  }
}

Header.defaultFocusPath = defaultFocusPath;

export default withAppState(Header);
